var exports = {
  "i": "LiveBadge.module__liveBadge___empsRD",
  "f": "LiveBadge.module__liveBadgeOnVoiceTile___empsRD",
};

module.exports = exports;
